import axios from "axios";
import { SET_LOADER, CLEAR_LOADER, CLEAR_ERRORS, GET_DELIVERY_PERSON, ADD_DELIVERY_PERSON } from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - GET DELIVERY PERSON INFO
 *****************************************/
export const get_delivery_person = (token) => async (
  dispatch
) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_data = await axios.get(
      `${serverApi}/delivery-persons`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_data.status === 200) {
      dispatch({
        type: GET_DELIVERY_PERSON,
        payload: get_data?.data
      })
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};


/***************************************
 * @DESC - DELETE DELIVERY PERSON INFO
 *****************************************/
export const delete_delivery_person = (token, personID, onCallAction) => async (
  dispatch
) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_data = await axios.delete(
      `${serverApi}/delivery-persons/${personID}`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_data?.status === 200) {
      onCallAction();
      Alert.success(`<h4>Person Deleted Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch(get_delivery_person(token));
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    Alert.error(`<h4>Something went wrong</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    dispatch(setErrors(err));
  }
};

/***************************************
* @DESC - ADD DELIVERY PERSON INFO
*****************************************/
export const add_delivery_person = (token, formData, onCallAction) => async (
  dispatch
) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let add_data = await axios.post(
      `${serverApi}/delivery-persons`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    if (add_data?.status === 201) {
      Alert.success(`<h4>Person Added Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch(get_delivery_person(token));
      dispatch({ type: CLEAR_LOADER });

    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    if (
      err.response &&
      err.response.status === 500
    ) {
      Alert.error(`<h4>User Already Exists. Please give another Phone number</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      Alert.error(`<h4>Something went wrong</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    // dispatch(setErrors(err));
  }
};


/***************************************
* @DESC - EDIT DELIVERY PERSON INFO
*****************************************/
export const edit_delivery_person = (token, formData, personID) => async (
  dispatch
) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let add_data = await axios.patch(
      `${serverApi}/delivery-persons/${personID}`, formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (add_data?.status === 200) {
      Alert.success(`<h4>Record Updated Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch(get_delivery_person(token));
      dispatch({ type: CLEAR_LOADER });

    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    Alert.error(`<h4>Something went wrong</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    dispatch(setErrors(err));
  }
};